import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { statements } from '../../../api';
import { useTranslation } from 'react-i18next';

export const useGenerateStatement = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation(
        ['generate-admin-statement'],
        ({ start_at, end_at, chain_id }) => statements.generate({ start_at, end_at, chain_id }),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries(['admin-statements']);
                toast.success(t('Success'));
            },
            onError: (e) => {
                toast.error(e.response?.data?.message);
            },
        }
    );
};
